import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import { SourceDataInitials } from '@/constants/SourceDataInitials';
import JWTUtils from './JWTUtils';
import theLocalStorageUtils from './LocalStorageUtils';
import TheConfigService from '@/services/TheConfigService';
import { DateTime } from 'luxon';

// TODO: Fix TS Errors and Warnings after removing the below line
/* eslint-disable */
export default {
    /**
     * Sleep the given number of milliseconds.
     * @param ms
     * @returns
     */
    sleep(ms: number | undefined) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },
    uuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
    ranStr(len = 7, casing = '') {
        let charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        if (casing === 'upper') {
            charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        } else if (casing === 'lower') {
            charSet = 'abcdefghijklmnopqrstuvwxyz';
        }
        let randomString = '';
        for (let i = 0; i < len; i++) {
            const randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz, randomPoz + 1);
        }
        return randomString;
    },
    isValueInArray(arr: any, value: any): boolean {
        return arr.indexOf(value) !== -1;
    },
    isKeyInObject(obj: any, key: any): boolean {
        return Object.keys(obj).some((v) => v == key);
    },
    isObjectEmpty(obj: any): boolean {
        return Object.keys(obj).length === 0 ? true : false;
    },
    objectSize(obj: any): number {
        return Object.keys(obj).length;
    },
    cleanObjectEmptyValue(obj: any) {
        for (const propName in obj) {
            if (!obj[propName]) {
                delete obj[propName];
            }
        }
        return obj;
    },
    redirectToErrorPage() {
        window.location.replace('Error');
        return false;
    },
    isNumber(n: any): boolean {
        return !isNaN(parseFloat(n)) && !isNaN(n - 0);
    },
    isUpperCase(str: string): boolean {
        return str === str.toUpperCase();
    },
    stringToBoolean(str: string): boolean {
        switch (str.toLowerCase().trim()) {
            case 'true':
            case 'yes':
            case '1':
                return true;
            case 'false':
            case 'no':
            case '0':
            case null:
                return false;
            default:
                return false;
        }
    },
    checkOverflowX(el: any): boolean {
        return el.clientWidth < el.scrollWidth;
    },
    checkOverflowY(el: any): boolean {
        return el.clientHeight < el.scrollHeight;
    },
    checkOverflow(el: any): boolean {
        return el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    },
    moveArrayItem(array: any, old_index: number, new_index: number) {
        if (new_index >= array.length) {
            let k = new_index - array.length + 1;
            while (k--) {
                array.push(undefined);
            }
        }
        array.splice(new_index, 0, array.splice(old_index, 1)[0]);
        return array;
    },
    getElementPositionById(elementId: string) {
        const element: HTMLElement | null = document.getElementById(elementId);
        let result = {
            bottom: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0,
            width: 0,
            x: 0,
            y: 0,
        };
        if (element !== null) {
            result = element.getBoundingClientRect();
        }
        return result;
    },
    getElementStylesById(elementId: string, style: string) {
        const element: HTMLElement | null = document.getElementById(elementId);
        let result = '';
        if (element !== null && style) {
            result = window.getComputedStyle(element, null).getPropertyValue(style);
        }

        return result;
    },
    removeElementById(elementId: string) {
        const element: HTMLElement | null = document.getElementById(elementId);
        if (element !== null) {
            element.remove();
        }
    },
    convertStringToNumber(stringNumber: string) {
        return parseInt(stringNumber, 10);
    },
    formatNumberToCommas(value: any) {
        if (parseInt(value) && !isNaN(value)) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return value;
    },
    formatValueToDate(value: any) {
        if (typeof value !== 'string') {
            return value;
        }

        const normalizedValue = value.trim();
        if (!normalizedValue) {
            return value;
        }

        const parsed = DateTime.fromFormat(normalizedValue, 'yyyy-MM-dd');
        if (!parsed.isValid) {
            return value;
        }

        return parsed.toFormat('MM/dd/yyyy');
    },
    initialDetails(initials: string) {
        switch (initials.toLowerCase()) {
            case SourceDataInitials.Database:
                return { id: '1', name: 'TOTAL Comp Database', initials: 'DB', title: 'TOTAL Comp Database' };
                break;
            case SourceDataInitials.Mls:
                return { id: '2', name: 'Your Area MLS', initials: 'MLS', title: 'Your Area MLS' };
                break;
            case SourceDataInitials.PublicRecords:
                return { id: '3', name: 'Public Records', initials: 'PR', title: 'Public Records' };
                break;
            case SourceDataInitials.SmartExchange:
                return { id: '4', name: 'SmartExchange', initials: 'SE', title: 'SmartExchange' };
                break;
            case SourceDataInitials.CustomValue:
                return { id: '5', name: 'Custom Value', initials: 'CV', title: 'Custom Value' };
                break;
            case SourceDataInitials.UserOverride:
                return { id: '', name: 'User Override', initials: 'UT', title: 'User manually changed the value' };
                break;
            case SourceDataInitials.FormFiller:
                return { id: '', name: 'Form Filler', initials: 'FF', title: 'Form Filler Override' };
                break;
            default:
                return { id: '', name: '', initials: '', title: '' };
        }
    },
    toUpperCase(str: string) {
        return str.toUpperCase();
    },
    toLowerCase(str: string) {
        return str.toLowerCase();
    },
    toSentenceCase(str: string) {
        let _this = this;
        return _this.toLowerCase(str).replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) {
            return _this.toUpperCase(c);
        });
    },
    toTitleCase(str: string) {
        const arr = this.toLowerCase(str).split(' ');
        for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        return arr.join(' ');
    },
    toCamelCase(str: string) {
        let _this = this;
        return str
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index === 0 ? _this.toLowerCase(word) : _this.toUpperCase(word);
            })
            .replace(/\s+/g, '');
    },
    getOffset(el: any) {
        const rect = el.getBoundingClientRect();
        return { top: rect.top, bottom: rect.bottom, left: rect.left, right: rect.right, height: rect.height, width: rect.width, x: rect.x, y: rect.y };
    },
    isJsonDifferent(json1: any, json2: any) {
        if (this.objectSize(json1) != this.objectSize(json2)) {
            return true;
        } else {
            let mismatch = false;
            for (const key in json1) {
                if (this.isKeyInObject(json2, key)) {
                    if (json1[key] !== json2[key]) {
                        mismatch = true;
                        break;
                    }
                } else {
                    mismatch = true;
                    break;
                }
            }

            if (mismatch) {
                return true;
            }
        }
        return false;
    },
    convertAssocArrToKeyValue(obj: any, key: string, value: string) {
        interface IResult {
            [key: string]: string;
        }

        let result: IResult = {};
        for (const item of obj) {
            if (this.isKeyInObject(item, key)) {
                result[item[key]] = item[value];
            }
        }
        return result;
    },
    convertKeysToLowerCaseFirstLetter(obj: any) {
        var json = JSON.stringify(obj);
        const output = json.replace(/"([\w]+)":/g, function ($0: any, $1: string) {
            return '"' + $1.charAt(0).toLowerCase() + $1.slice(1) + '":';
        });
        return JSON.parse(output);
    },
    debugger(): boolean {
        if (theLocalStorageUtils.hasKeyAndValue(LocalStorageKeys.debugByPPID)) {
            const ppid = Number(theLocalStorageUtils.get(LocalStorageKeys.debugByPPID));
            const jwtPpid = JWTUtils.getJWTPassportId();
            if (ppid === jwtPpid) {
                return true;
            }
        }

        return false;
    }

};
